import { useGetRequestTotals } from '@/modules/Requests/queries';
import { DashboardColumnStatus } from '@/shared';
import { t } from 'i18next';
import { KanbanColumn } from '../KanbanColumn';
import { useContext } from 'react';
import { FilterContext } from '@/components';

export const KanbanBoard = () => {
  const { showActiveOnly } = useContext(FilterContext);

  const { data: totals } = useGetRequestTotals(showActiveOnly);

  return (
    <div className="flex items-stretch gap-1">
      <KanbanColumn
        key="submitted"
        title={t(
          `kanban_board_${DashboardColumnStatus[DashboardColumnStatus.Submitted]}`,
        )}
        status={DashboardColumnStatus.Submitted}
        counter={totals?.nrRequestsSubmitted}
      />
      <KanbanColumn
        key="in_evaluation"
        title={t(
          `kanban_board_${DashboardColumnStatus[DashboardColumnStatus.InEvaluation]}`,
        )}
        status={DashboardColumnStatus.InEvaluation}
        counter={totals?.nrRequestsInEvaluation}
      />
      <KanbanColumn
        key="in_execution"
        title={t(
          `kanban_board_${DashboardColumnStatus[DashboardColumnStatus.InExecution]}`,
        )}
        status={DashboardColumnStatus.InExecution}
        counter={totals?.nrRequestsInExecution}
      />
      <KanbanColumn
        key="concluded"
        title={t(
          `kanban_board_${DashboardColumnStatus[DashboardColumnStatus.Concluded]}`,
        )}
        extraTitle={
          totals?.requestsArchived
            ? `${totals.requestsArchived} ${t('chart_archived_requests')}`
            : undefined
        }
        status={DashboardColumnStatus.Concluded}
        counter={totals?.nrRequestsConcluded}
      />
    </div>
  );
};
